<template>
  <div id="navbar">

    <div class="navbar-wrap" :class="{ pabs : isHome }">
        <div class="logo" :class="{ ani100 : isHome }" @click="growLogo()">
          <MeshLogo/>
        </div>
    </div>

  </div>
</template>

<script>
import MeshLogo from '@/components/MeshLogo.vue'

export default {
  name: 'Header',
  components: {
    MeshLogo
  },
  data() {
    return {
      grow: false,
      routeName: false
    }
  },
  created() {
      this.routeName = this.$route.name
      //This is because watch $route didn't work on landing start.
  },
  watch:{
      $route (to, from){
        this.routeName = this.$route.name
        //This updates the routeName for every page change
      }
  },
  computed: {
    isHome() {
      if (this.routeName === 'Home') { return true } else { return false }
    }
  },
  methods: {
    growLogo() {
      this.grow = !this.grow;
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";
@import "../scss/_classes.scss";

#navbar {
  .navbar-wrap {
      position: fixed;
      top: 0;
      width: 100%;
      @include useMargin(padding);
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
          color: rgb(255, 255, 255);
          mix-blend-mode: difference;

      .logo {
          width: 100px;
          // opacity: .1;
          transition: all .2s ease-in-out;
          &:hover {
            opacity: 1;
            cursor: pointer;
          }
      }
      .ani100 {
          width: 100%; 
          opacity: 1;           
      }
  }
  .pabs {
    position: absolute;
  }
}

</style>
